import './js/svg-sprite'
import './js/bator-scripts/script'

import {initPopupLists} from './js/popup-list/popup-list'
import {initForms} from './js/form'
import {initSearchContainers} from '@/app/js/search'
import {initSwipers} from '@/app/js/swiper'
import {initShowMore} from '@/app/js/show-more'
import {initQuantities} from '@/app/js/quantity'
import {initMmenu} from '@/app/js/mmenu'
import {initVue} from '@/app/vue'
import {initScrollTop} from '@/app/js/scroll-top'
import {initCoupons} from '@/app/js/coupon'
import {initAnalytics} from '@/app/js/analytics'
import {initCookieAgreement} from '@/app/js/cookie-agreement'
import {initAccordion} from '@/app/js/accordion'
import {handleStoreChanging} from '@/app/js/change-store'
import {initUpsell} from '@/app/js/upsell'
import {initSolution} from '@/app/js/solution'
import {initMobileSearchBtn} from '@/app/js/mobile-search-btn'
import {runProductScripts} from '@/app/js/product'
import {initExpandedButtons} from './js/expanded-button'
import {initVoucherForm} from '@/app/js/voucher'
import {initRemoveVouchers} from '@/app/js/remove-voucher'
import {initVoucherAmount} from '@/app/js/voucher-amount'
import {initApplyVouchers} from '@/app/js/apply-voucher'

initPopupLists()
initForms()
initSearchContainers()
initSwipers()
initShowMore()
initQuantities()
initMmenu()
initCoupons()
initVue()
initScrollTop()
initAnalytics()
initCookieAgreement()
initAccordion()
handleStoreChanging()
initUpsell()
initSolution()
initMobileSearchBtn()
runProductScripts()
initExpandedButtons()
initVoucherForm()
initRemoveVouchers()
initVoucherAmount()
initApplyVouchers()
